<div
  v-if="shouldRenderConfig && getFactsheet"
  v-bind:class="getClassName"
  class="matrix_table"
>
  <div
    v-bind:class="getClassNameContainer"
    v-for="(value, prodPartCode) in getFactsheet"
    v-bind:key="prodPartCode"
  >
    <!-- <div v-bind:class="getClassName + 'Header matrix_summaryHeader'">{{$t('Factsheet header')}}</div> -->
    <div
      v-bind:class="getClassNameItem"
      v-for="(files, fileType) in value.files"
    >
      <div
        v-bind:class="getClassNameItem"
        v-for="(fileData, fileKey) in files"
      >
        <a
          v-bind:href="fileData.path"
          target="_blank"
          v-bind:title="fileData.name"
          ><span class="matrix_arrowIcon"></span><span>{{$t('Download ') + fileData.name }}</span></a
        >
      </div>
    </div>
  </div>
</div>
